import React, { useEffect, useRef, useState } from 'react';
import useAdminRole from '../hooks/useAdminRole';
import { useContracts } from '../context/ContractContext';
import UserOps from '../components/sections/admin/UserOps';
import ConfigOps from '../components/sections/admin/ConfigOps';
import LevelOps from '../components/sections/admin/LevelOps';
import OwnerOps from '../components/sections/admin/OwnerOps';
import WithdrawOps from '../components/sections/admin/WithdrawOps';

const TABS = [
  { key: 'withdraws', label: 'Withdrawals' },
  { key: 'users',     label: 'User Ops' },
  { key: 'config',    label: 'Contract Config' },
  { key: 'levels',    label: 'Levels & Rewards' },
  { key: 'owner',     label: 'Roles & Wallets' }
];

export default function Admin() {
  const role = useAdminRole();
  const { main } = useContracts();
  const [tab, setTab] = useState('withdraws');
  const [pendingCount, setPendingCount] = useState(null);
  const mountedRef = useRef(true);

  useEffect(() => {
    mountedRef.current = true;
    const load = async () => {
      try {
        const c = await main.pendingWithdrawCount();
        if (mountedRef.current) setPendingCount(Number(c.toString()));
      } catch (_) {}
    };
    load();
    const iv = setInterval(load, 20000);
    return () => { mountedRef.current = false; clearInterval(iv); };
  }, [main]);

  const badge = role.isOwner ? 'OWNER'
              : role.isAdmin ? 'ADMIN'
              : role.isHelper ? 'HELPER' : '';

  return (
    <div className="fade-in">
      <div className="page-header">
        <div>
          <h2 className="page-title">
            <span className="title-accent">⚙</span> Admin Panel
          </h2>
          <div className="page-subtitle">Contract control · Restricted area</div>
        </div>
        {badge && <span className="badge badge-warning">{badge}</span>}
      </div>

      <div className="tabs">
        {TABS.map((t) => (
          <div
            key={t.key}
            className={`tab ${tab === t.key ? 'active' : ''}`}
            onClick={() => setTab(t.key)}
          >
            {t.label}
            {t.key === 'withdraws' && pendingCount > 0 && (
              <span className="badge badge-warning" style={{ marginLeft: 8, padding: '2px 8px', fontSize: 10 }}>
                {pendingCount}
              </span>
            )}
          </div>
        ))}
      </div>

      {tab === 'withdraws' && <WithdrawOps />}
      {tab === 'users'     && <UserOps />}
      {tab === 'config'    && <ConfigOps />}
      {tab === 'levels'    && <LevelOps />}
      {tab === 'owner'     && <OwnerOps role={role} />}
    </div>
  );
}
